import { DatasetsApi } from '@api';
import { ExistingFile, NewFile, UploadedFile } from '@types';

import { ErrorHelper } from './error';

const createDocuments = async (documents: UploadedFile[], datasetsApi: DatasetsApi): Promise<number[]> => {
  const results = await Promise.all(
    documents.map(async (document: UploadedFile) => {
      if ('documentId' in document && (document as ExistingFile).documentId != null) {
        return (document as ExistingFile).documentId as number;
      }
      try {
        const createdDocument = await datasetsApi.apiDatasetsDocumentsCreate({
          fileName: document.name,
          file: (document as NewFile).file,
        });
        return createdDocument.id;
      } catch (error) {
        ErrorHelper.handleErrorNotification(error);
        return null;
      }
    }),
  );

  return results.filter((id): id is number => id != null);
};

export const DocumentsHelper = {
  createDocuments,
};
